(function () {
  'use strict';

  function initStickyCart() {
    // Product pages only
    if (!window.location.pathname.includes('/products/')) return;

    // Mobile only
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    // Find the real/main Add to Cart button
    const mainButton =
      document.querySelector('.main-product-atc') ||
      document.querySelector('button[name="add"]') ||
      document.querySelector('form[action*="/cart/add"] button[type="submit"]');

    // Find Shrine's existing sticky ATC
    const sticky =
      document.querySelector('sticky-atc');

    if (!mainButton || !sticky) {
      console.log(
        '[Sticky ATC] Could not find:',
        {
          mainButton: !!mainButton,
          sticky: !!sticky
        }
      );
      return;
    }

    // Prevent duplicate initialization
    if (sticky.dataset.customStickyReady === 'true') return;
    sticky.dataset.customStickyReady = 'true';

    console.log('[Sticky ATC] Initialized');

    function update() {
      // Desktop = always hidden
      if (!window.matchMedia('(max-width: 749px)').matches) {
        sticky.classList.remove('custom-sticky-active');
        return;
      }

      const rect = mainButton.getBoundingClientRect();

      /*
       * Main Add To Cart is visible on screen
       */
      if (
        rect.top < window.innerHeight &&
        rect.bottom > 0
      ) {
        sticky.classList.remove('custom-sticky-active');
        return;
      }

      /*
       * Main ATC has gone ABOVE the screen.
       * This means the customer swiped DOWN past it.
       */
      if (rect.bottom <= 0) {
        sticky.classList.add('custom-sticky-active');
        return;
      }

      /*
       * Main ATC is below the screen.
       * Don't show sticky.
       */
      sticky.classList.remove('custom-sticky-active');
    }

    /*
     * Sticky button should use the REAL product
     * Add To Cart button.
     */
    const stickyButton =
      sticky.querySelector('button[type="submit"]') ||
      sticky.querySelector('.sticky-atc__add_button') ||
      sticky.querySelector('button');

    if (stickyButton) {
      stickyButton.addEventListener('click', function (event) {
        event.preventDefault();

        mainButton.click();
      });
    }

    // Initial state
    sticky.classList.remove('custom-sticky-active');

    // Scroll
    window.addEventListener(
      'scroll',
      update,
      { passive: true }
    );

    // Resize
    window.addEventListener(
      'resize',
      update,
      { passive: true }
    );

    update();
  }

  /*
   * Shrine can load/re-render product sections,
   * so try several times during initialization.
   */
  document.addEventListener(
    'DOMContentLoaded',
    initStickyCart
  );

  window.addEventListener(
    'load',
    initStickyCart
  );

  setTimeout(initStickyCart, 500);
  setTimeout(initStickyCart, 1500);
  setTimeout(initStickyCart, 3000);

})();